module.exports = __webpack_public_path__ + "static/media/iconResolved.f9fe75ce.svg";